import React from 'react';
import { Button, Grid } from '@mui/material';

import Logo from 'ui-component/LoginLogo';
import { IconHelp } from '@tabler/icons-react';

const AuthHeader = () => {
    return (
        <>
            <Grid sx={{ px: { xl: 20, md: 10 } }} container alignItems={'flex-start'} justifyContent={'space-between'}>
                <Grid item sx={{ display: { md: 'block', xs: 'none' }, m: 3, maxHeight: '1rem' }}>
                    <Logo color="secondary" />
                </Grid>
                <Grid item sx={{ display: { md: 'flex', xs: 'none' }, gap: 1.5, textAlign: 'right', m: 3 }}>
                    <Button
                        color="secondary"
                        size="large"
                        href="mailto:developer@tlrg.com.au"
                        startIcon={<IconHelp />}
                        target="_blank"
                        sx={{ fontSize: '1rem' }}
                    >
                        Need Help?
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default AuthHeader;
